'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
Entry.BlockRenderModel = /*#__PURE__*/(0, _createClass2["default"])(function BlockRenderModel() {
  (0, _classCallCheck2["default"])(this, BlockRenderModel);
  this.schema = {
    id: 0,
    type: Entry.STATIC.BLOCK_RENDER_MODEL,
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    magneting: false
  };
  Entry.Model(this);
});